<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"title="Welcome to Soul Space" subtitle="Welcome to Soul Space"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


        <!-- OUR TEAM START -->
        <!-- <app-team-profile [profile]="profile"></app-team-profile> -->
        <!-- OUR TEAM SECTION END -->


        <!-- BUILD FUTURE START -->
        <!-- <app-team-skills [data]="skills"></app-team-skills> -->
        <!-- BUILD FUTURE END -->

        <!-- OUR TEAM START -->
        <!-- <app-team4 [data]="teamSection" back="white"></app-team4> -->
        <!-- OUR TEAM SECTION END -->


    </div>
    <!-- CONTENT END -->

    <div class="container">
    <div class="row align-items-center">
        <!-- Left Side: Image -->
        <div class="col-lg-6 col-md-12 m-b10">
            <div class="image-container text-center mt-5 mb-4 mobwelco">
                <img src="assets/images/Welcometosoulpace" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
            </div>
        </div>
    
        <!-- Right Side: Text Content -->
        <div class="col-lg-6 col-md-12">
            <div class="text-content">
                <div class="separator-line mb-4"></div>
                <!-- <h5>Welcome to Soul Space</h5> -->
                <p>
                    Soul Space is a sanctuary, where your wellness is our priority. At Soul Space, we
                    believe that the harmony between mind, body and soul is the key to nurture one’s
                    mental health and overall wellbeing. A wide range of customized mental health care
                    and wellness services are tailored by our compassionate professionals to meet your
                    unique journey. While you navigate through different life challenges, we are here to
                    guide you, and provide you with the support you deserve.
                    <br><br>
                    At Soul Space, we aim at your holistic wellbeing by taking into account your physical,
                    emotional, mental and social wellness. Our clinic is a warm and welcoming space
                    designed for you to feel supported, understood and empowered. We strive to
                    enhance your quality of life by empowering you with resources and strategies to
                    build resilience and foster self-care. Here we are to walk alongside your journey
                    towards healing or maintaining your path to wellness. Take your first step towards
                    your journey and together we can help you embrace a more balanced, healthier and
                    fulfilling life.
                </p>
    
                
            </div>
        </div>
    </div>
</div>


    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>